import { Node } from '../../Node';
/**
 * @category Flow shape
 */
export class FrameFlattenNode extends Node {
  constructor(options) {
    super(options);
    this.on('push', this._onPush.bind(this));
  }
  _onPush(frames, options) {
    return new Promise(resolve => {
      frames.map(frame => this.outlets.forEach(outlet => outlet.push(frame, options)));
      resolve();
    });
  }
}